<studio-card>
  <h3>{{ message }}</h3>
  <studio-button-legacy (click)="buttonClicked()" type="submit" theme="dark-primary">{{
    actionLabel
  }}</studio-button-legacy>
</studio-card>
